@if (store.isHealthCare() || store.isSocial()) {
    @if (store.allowViewAllHistory()) {
        <div class="flex justify-content-end">
            <app-button
                [text]="true"
                [label]="store.viewAllHistory() ? 'folder.status.message.viewHide' : 'folder.status.message.viewAll'"
                (clickEvent)="store.triggerAllHistory()"
            ></app-button>
        </div>
    }

    @if (store.history() && store.history().length) {
        <div class="input-grid-gaps-small entries-wrapper">
            @for (item of store.history(); track $index) {
                <app-tag
                    [severity]="$any(personStatusColor[item.key])"
                    [label]="'folder.status.value.' + item.key"
                    [rounded]="true"
                ></app-tag>
                <div>
                    {{ item.value[0] | shortDate }}
                    @if (item.value[1]) {
                        <span>-&nbsp;{{ item.value[1] | shortDate }}</span>
                    }
                </div>
            }
        </div>
    } @else {
        <app-empty-state></app-empty-state>
    }
} @else {
    <app-empty-state></app-empty-state>
}
